(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/swedbankpay-checkout/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/accountservices/swedbankpay-checkout/assets/javascripts/prescript.js');

'use strict';

svs = svs || {};
svs.accountservices = svs.accountservices || {};
svs.accountservices.swedbankpay_checkout = svs.accountservices.swedbankpay_checkout || {};

 })(window);